import { useState, useEffect, useMemo } from "react";

const EditView = ({ columns, item, setItem, post }) => {
    const [oldItem, setOldItem] = useState(null);

    const submit = async e => {
        e.preventDefault();
        if (await (post(new FormData(e.target)))) setOldItem(item);
    }

    useEffect(() => {
        if (!oldItem && item) setOldItem(item)
    }, [item, oldItem]);

    const check = useMemo(() => {
        const res = JSON.stringify(item).localeCompare(JSON.stringify(oldItem));
        return res;
    }, [item, oldItem]);

    return <form className="card" onSubmit={submit}>
        {columns.map((column) => <div key={column.key} className="group">
            <label>{column.label}</label>
            <input
                type="text"
                placeholder={column.placeholder || column.label}
                name={column.key}
                required={column.required || false}
                value={item[column.key] || ""}
                onChange={e => setItem({ ...item, [column.key]: e.target.value })}
            />
        </div>)}

        {Boolean(check && item) && <button type="submit">Sauvegarder</button>}
    </form>
}

export default EditView;